/**
 * 车险管理-订单列表
 */

export default {
    name: 'AutoInsuranceOrderList',
    path: '/AutoInsuranceOrderList',
    component: () => import('@/views/vehicleInsuranceOrderList/'),
    redirect: { name: 'AutoInsuranceOrderListIndex' },
    meta: {
        title: '订单列表',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: 'AutoInsuranceOrderListIndex',
            path: 'index',
            component: () => import('@/views/vehicleInsuranceOrderList/home/Home.vue'),
        },
        {
            name: 'AutoInsuranceOrderListDetail',
            path: 'read',
            component: () => import('@/views/vehicleInsuranceOrderList/detail/Detail.vue'),
        },
    ],
};
